import { Pie } from 'react-chartjs-2';

const Piechart = ({ dineinTabs }) => {

  const totalFood = Number(dineinTabs.FoodSale) || 0;
  const totalBeverage = Number(dineinTabs.BeverageSale) || 0;
  const totalOthers = Number(dineinTabs.OtherSale) || 0;

  const totalSum = totalFood + totalBeverage + totalOthers;

  return (
    <div className='show-pie-chart py-2 pb-4'>

      <Pie
        className='pie-chart max-w-full w-full overflow-hidden'
        data={{
          datasets: [
            {
              label: 'Number of Sales',
              data: [totalFood, totalBeverage, totalOthers],
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
              ],
              borderWidth: 1,
            },
          ],
          labels: ['Food Sales', 'Beverage Sales', 'Other Sales'],
        }}
      />

      {totalSum > 0 ? (
        <div className="text-sm mt-3 space-y-1.5 flex justify-center items-center flex-col">
          <div className='font-semibold'>Sales Distribution (%)</div>

          <div>
            <span>Food: </span>
            {((totalFood / totalSum) * 100).toFixed(2)}%
          </div>

          <div>
            <span>Beverage: </span>
            {((totalBeverage / totalSum) * 100).toFixed(2)}%
          </div>

          <div>
            <span>Others: </span>
            {((totalOthers / totalSum) * 100).toFixed(2)}%
          </div>
        </div>
      ) : (
        <p className='text-sm text-center font-semibold'>
          No sales data available.
        </p>
      )}

    </div>
  );
};

export default Piechart;